module.exports = __webpack_public_path__ + "img/box9-img-4.8f27ad85.png";